/* eslint-disable max-len */
export const translations = {
  DELIVERY_IMPORT: 'Lieferdetails hochladen',
  LOADING_IMPORT: 'Ladedaten hochladen',
  FREIGHT_IMPORT: 'Frachtdetails hochladen',
  MASTER_IMPORT: 'Stammdaten hochladen',
  START_IMPORT: 'Import starten',
  APP_TITLE: 'Daten-Uploader | Jules AI',
  LOGISTIC_FORWARDER: 'Logistikspediteur auswählen',
  LOGISTIC_FORWARDER_NAME: 'Logistischer Spediteur',
  SHIPPING_LINE_NAME: 'Schifffahrtslinie',
  LOADING_UNIT: 'Volumeneinheit & Ladeart',
  DELIVERY_UNIT: 'Volumeneinheit & Lieferart',
  GO: 'Weiter zu',
  GO_BACK: 'Zurückgehen',
  IMPORT_DATA: 'Daten importieren',
  IMPORT_DELIVERIES: 'Lieferungen importieren',
  IMPORT_LOADINGS: 'Ladungen importieren',
  CHECKOUT_DELIVERIES_ON_APP: 'Lieferungen in der Webanwendung abfragen',
  CHECKOUT_LOADINGS_ON_APP: 'Ladungen in der Webanwendung abrufen',
  POPUP_VALIDATION: 'Erforderlich',
  POPUP_LOADING_VALIDATION: 'Alle Felder sind obligatorisch',
  LOADING_TYPE: 'Beladungsart wählen',
  DELIVERY_TYPE: 'Lieferart wählen',
  VALIDITY_MONTH: 'Gültigkeitsmonat wählen',
  LOGISTIC_MATERIAL: 'Logistisches Material auswählen',
  QUALITY_GROUP: 'Qualitätsgruppe wählen',
  INCO_TERMS: 'Incoterm wählen',
  LOGISTIC_FORWARDER_SHIPPING_LINE: 'Wert wählen',
  FREIGHT_POPUP: 'Wählen Sie untenstehende Details',
  INVALID_CREDENTIALS: 'Ihre E-Mail und/oder Ihr Passwort sind nicht korrekt',
  VALID_CREDENTIALS: 'Anmeldung erfolgreich',
  SAMPLE_TEMPLATE: 'Vorlage herunterladen',
  SUPPORT_HELP: 'Unterstützung',
  CONTRACT_IMPORT: 'Details zur Vertragsverlängerung',
  CONTRACT: 'Vertrag erneuern',
  CONFIRMATION_TEXT:
    'Sind Sie sicher, dass Sie die Datensätze verlängern möchten?',
  CONFIRMATION_YES: 'Ja',
  CONFIRMATION_NO: 'Nein',
  RENEW: 'Erneuern',
  RENEWING_TEXT: 'Erneuerung der Aufzeichnungen',
  FROM: 'von',
  TO: 'an',
  LOADINGS_HEADER: 'Ladungen',
  DELIVERIES_HEADER: 'Lieferungen',
  FREIGHT_HEADER: 'Fracht',
  MASTER_HEADER: 'Master',
  CONTRACT_RENEWAL_HEADER: 'Vertragserneuerung',
  LOGOUT: 'Abmeldung',
  VOLUME_UNIT: 'Volumeneinheit wählen',
  MATERIAL: 'Werkstoff',
  ITEM: 'Artikel',
  LOADING_TEXT: 'Bitte warten',
  'The commodity or material name': 'Die Waren- oder Materialbezeichnung',
  'The material name cannot be blank': 'Der Materialname darf nicht leer sein',
  'Net Weight': 'Nettogewicht',
  'Quantity of material in delivery': 'Menge des Materials in der Lieferung',
  'Quantity cannot be left blank': 'Menge kann nicht leer gelassen werden',
  'Date of delivery': 'Datum der Lieferung',
  'Date of delivery cannot be left blank':
    'Lieferdatum kann nicht leer gelassen werden',
  'Reference number': 'Referenznummer',
  'Container reference number': 'Container-Referenznummer',
  'ERP Container id': 'ERP-Behälter-Nummer',
  'Gross Weight': 'Bruttogewicht',
  'Maximum Gross Weight': 'Maximales Bruttogewicht',
  'General comment': 'Allgemeiner Kommentar',
  'Loading comment': 'Bemerkung zur Beladung',
  'Delivery comment': 'Kommentar zur Lieferung',
  'Tare Weight': 'Taragewicht',
  'Packages': 'Pakete',
  'Quantity in tons': 'Menge in Tonnen',
  'Quantity converted to tons': 'Menge umgerechnet in Tonnen',
  'Quality id': 'Qualitätskennung',
  'The id linked to the quality name':
    'Die mit dem Qualitätsnamen verknüpfte Kennung',
  'Container id': 'Behälter-Kennung',
  'The truck plate number or container reference number':
    'Kennzeichen des Lastwagens oder Referenznummer des Containers',
  'Jules number': 'Jules-Nummer',
  'CT number for the truck or container':
    'KV-Nummer für den Lkw oder Container',
  'Other delivery number': 'Andere Lieferungsnummer',
  'Any other delivery reference number': 'Jede andere Lieferreferenznummer',
  'Buy operation id': 'Nummer des Einkaufsvorgangs',
  'Sell operation id': 'Nummer des Verkaufsvorgangs',
  'Container operation quality id': 'Qualitätskennung des Containervorgangs',
  'Unit (qty)': 'Einheit (Menge)',
  'Seal number': 'Siegelnummer',
  'Container seal number': 'Nummer der Versiegelung des Behälters',
  'Thickness': 'Dicke',
  'Unit (thickness)': 'Einheit (Dicke)',
  'Length': 'Länge',
  'Unit (length)': 'Einheit (Länge)',
  'Width': 'Breite',
  'Unit (width)': 'Einheit (Breite)',
  'Height': 'Höhe',
  'Unit (height)': 'Einheit (Höhe)',
  'Unit (dimensions)': 'Einheit (Abmessungen)',
  'User delivery type': 'Art der Benutzerlieferung',
  'Package Reference': 'Paket-Referenz',
  'Delivery tare weight quantity': 'Menge des Liefertaragewichts',
  'Delivery tare weight cannot be left blank':
    'Liefertaragewicht kann nicht leer gelassen werden',
  'Delivery tare weight volume': 'Taragewicht Volumen Lieferung',
  'Delivery tare volume cannot be left blank':
    'Liefertaravolumen kann nicht leer gelassen werden',
  'Height cannot be left blank': 'Höhe kann nicht leer gelassen werden',
  'Height unit cannot be left blank':
    'Höheneinheit kann nicht leer gelassen werden',
  'Dimension unit cannot be left blank':
    'Maßeinheit kann nicht leer gelassen werden',
  'Thickness cannot be left blank': 'Dicke kann nicht leer gelassen werden',
  'Thickness unit cannot be left blank':
    'Einheit (Dicke) kann nicht leer gelassen werden',
  'If you press the \"Go back\" button, you will lose the progress of the current step.':
    // eslint-disable-next-line max-len
    'Wenn Sie die Schaltfläche "Zurückgehen" drücken, verlieren Sie den Fortschritt des aktuellen Schritts.',
  'If you press the \"Go back\" button, you will lose the entire progress of all steps.':
    'Wenn Sie die Taste \"Zurückgehen\" drücken, verlieren Sie den gesamten Fortschritt aller Schritte.',
  // eslint-disable-next-line max-len
  'Are you sure you want to submit your data? Rows with an error wont be imported. If yes, please use the “Submit” button. Otherwise, press the “Back” button':
    // eslint-disable-next-line max-len
    'Sind Sie sicher, dass Sie Ihre Daten übermitteln wollen? Zeilen mit einem Fehler werden nicht importiert. Wenn ja, verwenden Sie bitte die Schaltfläche "Senden". Andernfalls drücken Sie die Schaltfläche "Zurück".',
  // eslint-disable-next-line max-len
  'Are you sure you want to submit your data? If yes, please use the “Submit” button. Otherwise, press the “Back” button':
    // eslint-disable-next-line max-len
    'Sind Sie sicher, dass Sie Ihre Daten übermitteln wollen? Wenn ja, klicken Sie bitte auf die Schaltfläche "Senden". Andernfalls drücken Sie die Schaltfläche "Zurück".',
  // eslint-disable-next-line max-len
  'Are you sure you want to submit your data? Rows with an error will be imported as well. If yes, please use the “Submit” button. Otherwise, press the “Back” button':
    // eslint-disable-next-line max-len
    'Sind Sie sicher, dass Sie Ihre Daten übermitteln wollen? Zeilen mit einem Fehler werden ebenfalls importiert. Wenn ja, verwenden Sie bitte die Schaltfläche "Senden". Andernfalls drücken Sie die Schaltfläche "Zurück".',
  // eslint-disable-next-line max-len
  'Your import resulted in {{error}} errors. If you want to correct these errors inside the application, press the “Continue” button. Otherwise, you could download the merged table as Excel (.xlsx) by pressing the “Export as Excel” button.':
    // eslint-disable-next-line max-len
    'Ihr Import hat zu {{error}} Fehlern geführt. Wenn Sie diese Fehler innerhalb der Anwendung korrigieren möchten, klicken Sie auf die Schaltfläche "Weiter". Andernfalls können Sie die zusammengeführte Tabelle als Excel (.xlsx) herunterladen, indem Sie auf die Schaltfläche "Als Excel exportieren" klicken.',
  'Port of loading': 'Verladehafen',
  'Port of loading should not be blank': 'Verladehafen sollte nicht leer sein',
  'Port of destination': 'Bestimmungshafen',
  'Port of destination should not be blank':
    'Der Bestimmungshafen sollte nicht leer sein',
  'Shipping line': 'Versandlinie',
  'Shipping line should not be left blank':
    'Die Versandzeile sollte nicht leer bleiben',
  'Material group': 'Warengruppe',
  'Material group should not be left blank':
    'Die Warengruppe sollte nicht leer bleiben',
  'Cost':'Kosten',
  'Cost currency':'Währung der Kosten', 
  'Comment':'Kommentar', 
  'Other cost':'Andere Kosten',
  'Other cost currency':'Währung der sonstigen Kosten',
  'BL cost':'BL Kosten',
  'BL currency':'BL-Währung',
  'Customs currency': 'Währung des Zolls',  
  'Freight cost': 'Frachtkosten',
  'Freight cost should not be left blank':
    'Frachtkosten sollten nicht leer gelassen werden',
  'Freight cost currency code': 'Währungscode für Frachtkosten',
  'Logistic forwarder': 'Logistischer Spediteur',
  'Logistic material': 'Logistisches Material',
  'Incoterm': 'Incoterm',
  'Comment': 'Kommentar',
  'Other cost': 'Andere Kosten',
  'Other cost currency': 'Sonstige Kosten Währung',
  'Comment on freight': 'Kommentar zur Fracht',
  'Last validity date': 'Letztes Gültigkeitsdatum',
  'First validity date': 'Erstes Gültigkeitsdatum',
  'Cost volume': 'Kostenvolumen',
  'Cost volume should not be left blank':
    'Kostenvolumen sollte nicht leer gelassen werden',
  'BL cost value': 'BL-Kostenwert',
  'Currency code of BL cost': 'Währungscode der BL-Kosten',
  'Miscellaneous cost': 'Sonstige Kosten',
  'Currency code of THC admin cost': 'Währungscode der THC-Verwaltungskosten',
  'Other cost volume': 'Sonstiges Kostenvolumen',
  'Other cost volume should not be left blank':
    'Das Volumen der sonstigen Kosten sollte nicht leer gelassen werden',
  'Customs cost': 'Zollkosten',
  'Currency code of custom cost': 'Währungscode der Zollkosten',
  'Select validity month':'Gültigkeitsmonat auswählen',
  'Select logistic material':'Logistisches Material auswählen',
  'Select quality group':'Qualitätsgruppe wählen',
  'Select incoterm':'Incoterm wählen',
  'Check out freights on web app':'Frachten in der Web-App abfragen',
  'Import Freight':'Import-Fracht',
  'Date of loading': 'Datum der Verladung',
  'Date of loading cannot be left blank':'Datum der Verladung kann nicht leer gelassen',
  'Container / Truck number':'Container-/LKW-Nummer',
  'MGW':'MGW',
  'Weight unit':'Gewichtseinheit',
  'Material ID':'Werkstoff-ID',
  'User loading type':'Benutzer-Ladetyp',
  'ERP container ID':'ERP-Behälter-ID',
  'Transport Rate':'Transporttarif',
  'Upload transport rate details':'Details zum Transporttarif hochladen',
  'Select transport mode':'Transportart auswählen',
  'Barge': 'Barge',
  'Rail': 'Rail',
  'Road': 'Road',
  'Select transport type':'Transportart wählen',
  'Select material group':'Materialgruppe wählen',
  'Check out transport rates on web app':'Transporttarife in der Web-App abfragen',
  'Transport cost currency code':'Transportkosten-Währungscode',
  'Carrier':'Spediteur',
  'Loading area':'Ladebereich',
  'Destination area':'Zielgebiet',
  'Logistics':'Logistik',
  'Import transport rate':'Tarif für Importtransport',
  'Transport mode': 'Verkehrsträger',
  'cost': 'Kosten',
  'Volumic customs cost':'Volumic Zollkosten',
  'Volumic customs currency':'Volumenzoll Währung',
  'Currency code of volumic customs':'Währungscode des volumetrischen Zolls',
  'Volumic customs volume':'Volumenzoll-Volumen',
  "Volumic customs volume shouldn't be left blank":"Das volumische Zollvolumen sollte nicht leer gelassen werden",
  'Demurrage in days':'Liegegeld in Tagen',
  'Detention in days':'Verzögerung in Tagen',
  'Lane':'Fahrspur',
  'First validity date cannot be left blank' :'Das erste Gültigkeitsdatum kann nicht leer gelassen werden',
  'Last validity date cannot be left blank' :'Letztes Gültigkeitsdatum kann nicht leer gelassen werden',
  "Transport All In Rate": "Transport Pauschalpreise",
  "Pre-carriage area": "Bereich vor der Kutsche",
  "Pre carriage volume": "Volumen previo al transporte",
  "Pre carriage cost": "Coste de transporte previo",
  "Pre carriage currency": "Moneda anterior al transporte",
  "Packing type": "Art der Verpackung",
  "Single container": "Einzelner Container",
  "Multiple container": "Mehrere Container",
  "UPLOAD_TYPE": "Upload-Typ auswählen",
  CONFIRMATION_TEXT_SAMPLE_DOC: "Wenn Sie ein Problem beim Öffnen der Datei in Excel gefunden haben, klicken Sie bitte auf Ja",
  CONFIRMATION_CONTINUE: 'Weiter',
  CONFIRMATION_CANCEL: 'Abbrechen',
  "Select deviation type": "Abweichungstyp auswählen",
  "Sterile Weight": "Steril Gewicht",
  "Sterile Gross Weight": "Steril Bruttogewicht",
  "Pieces": "Stücke",
  "Upload container info": "Container-Info hochladen",
  "Delivery info": "Infos zur Lieferung",
  "Loading info": "Infos zur Beladung",
  "Logistic rates": "Logistische Tarife",
  "Export": "Ausfuhr",
  "Local": "Lokal",
  "Upload transactional data details":"Details zu Transaktionsdaten hochladen",
  "Transactional import":"Transaktioneller Import",
  "Select quality name":"Qualitätsname auswählen",
  "Volume unit, loading type & date of loading": 'Volumeneinheit, Ladeart und Ladedatum',
  "Volume unit, loading type & date of delivery": 'Volumeneinheit, Art der Verladung und Lieferdatum',
};
